import React from 'react';

import { neptuneUrls } from '@neptune/shared/common-domain';
import { bemBlock, Layout, Link } from '@neptune/shared/venus-ui';

import { KeycloakLogo } from './KeycloakLogo';

import './KeycloakScene.less';

const block = bemBlock('keycloak-scene');

type KeycloakSceneProps = {
  'data-role'?: string;
};

export const KeycloakScene: React.FC<KeycloakSceneProps> = ({
  'data-role': dataRole,
  children,
}) => {
  return (
    <Layout.Row className={block()} height="100%" data-role={dataRole}>
      <main className={block('main')}>
        <KeycloakLogo className={block('logo')} size={36} />
        <article className={block('content')}>{children}</article>
        <footer className={block('help')}>
          Any questions?{' '}
          <Link external href={neptuneUrls.documentation}>
            We&apos;re happy to help
          </Link>
        </footer>
      </main>
    </Layout.Row>
  );
};
